// extracted by mini-css-extract-plugin
export default {"limitDisplay":"LimitDisplay_limitDisplay__potLx","progress":"LimitDisplay_progress__5Xo7P","limitAmounts":"LimitDisplay_limitAmounts__XGFRe"};